/* ============================================================
   WiseQuest custom theme — interactions
   - FAQ accordion
   - Mobile nav drawer
   - Sticky buy bar (show after hero, hide near pricing)
   - AJAX add-to-cart -> opens the theme cart drawer
   - Variant -> price sync for simple product buy sections
   Namespaced, dependency-free, defensive (works even if a
   given feature isn't present on the page).
   ============================================================ */
(function () {
  'use strict';

  var routes = window.routes || {};
  var CART_ADD = routes.cart_add_url || '/cart/add.js';
  var CART_URL = routes.cart_url || '/cart';

  /* ---------- 1. FAQ accordions ------------------------------ */
  function initFaq(root) {
    (root || document).querySelectorAll('.wq .faq__q').forEach(function (btn) {
      if (btn.dataset.wqBound) return;
      btn.dataset.wqBound = '1';
      btn.setAttribute('aria-expanded', btn.closest('.faq__item').classList.contains('is-open') ? 'true' : 'false');
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- 2. Mobile nav drawer --------------------------- */
  function initMobileNav(root) {
    (root || document).querySelectorAll('.wq .site-header').forEach(function (header) {
      var toggle = header.querySelector('.site-header__mobile-toggle');
      var menu = header.querySelector('.site-header__mobile-menu');
      if (!toggle || !menu || toggle.dataset.wqBound) return;
      toggle.dataset.wqBound = '1';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', function () {
        var open = menu.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('wq-no-scroll', open);
      });
      menu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          menu.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('wq-no-scroll');
        });
      });
    });
  }

  /* ---------- 3. Sticky buy bar ------------------------------ */
  function initStickyBar(root) {
    (root || document).querySelectorAll('.wq .sticky-buy').forEach(function (bar) {
      if (bar.dataset.wqBound) return;
      bar.dataset.wqBound = '1';
      var anchorSel = bar.getAttribute('data-wq-anchor') || '.phero, .hero, .pblock';
      var hideSel = bar.getAttribute('data-wq-hide-at') || '#pricing, #buy';
      function anchorBottom() {
        var el = document.querySelector(anchorSel);
        if (!el) return 400;
        var r = el.getBoundingClientRect();
        return r.bottom + window.scrollY - 120;
      }
      var hideEl = document.querySelector(hideSel);
      function hideTopFn() {
        return hideEl ? hideEl.getBoundingClientRect().top + window.scrollY : Infinity;
      }
      var hideTop = hideTopFn();
      function nearHide() {
        return (window.scrollY + window.innerHeight) > hideTop + 40;
      }
      var threshold = anchorBottom();
      function onScroll() {
        if (window.scrollY > threshold && !nearHide()) bar.classList.add('is-on');
        else bar.classList.remove('is-on');
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { threshold = anchorBottom(); hideTop = hideTopFn(); onScroll(); });
      onScroll();
    });
  }

  /* ---------- 4. AJAX add to cart ---------------------------- */
  function drawerSections() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    }
    return 'cart-drawer,cart-icon-bubble';
  }

  function refreshCartCount() {
    fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.wq [data-wq-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count < 1;
        });
      })
      .catch(function () {});
  }

  function setBtnState(btn, state, labelText) {
    if (!btn) return;
    if (state === 'loading') {
      btn.dataset.wqLabel = btn.dataset.wqLabel || btn.innerHTML;
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = 'Adding…';
    } else if (state === 'done') {
      btn.innerHTML = labelText || 'Added ✓';
      setTimeout(function () {
        btn.removeAttribute('aria-busy');
        if (btn.dataset.wqLabel) btn.innerHTML = btn.dataset.wqLabel;
      }, 1400);
    } else {
      btn.removeAttribute('aria-busy');
      if (btn.dataset.wqLabel) btn.innerHTML = btn.dataset.wqLabel;
    }
  }

  function addItemsToCart(items, btn) {
    if (!items || !items.length) { window.location = CART_URL; return; }
    setBtnState(btn, 'loading');
    var body = {
      items: items,
      sections: drawerSections(),
      sections_url: window.location.pathname
    };
    fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          setBtnState(btn, 'reset');
          alert((res.data && res.data.description) || 'Could not add to cart.');
          return;
        }
        setBtnState(btn, 'done');
        refreshCartCount();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res.data);
        } else if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          window.location = CART_URL;
        }
      })
      .catch(function () { setBtnState(btn, 'reset'); window.location = CART_URL; });
  }

  function addToCart(variantId, quantity, btn) {
    if (!variantId) { window.location = CART_URL; return; }
    addItemsToCart([{ id: Number(variantId), quantity: quantity || 1 }], btn);
  }

  document.addEventListener('click', function (e) {
    var cartToggle = e.target.closest('[data-wq-cart-toggle]');
    if (cartToggle) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('is-empty')) {
        e.preventDefault();
        drawer.open(cartToggle);
      }
      return;
    }
    var trigger = e.target.closest('[data-wq-add]');
    if (!trigger) return;
    var variantIds = trigger.getAttribute('data-variant-ids');
    if (variantIds) { // bundle: add several variants in one request
      var ids = variantIds.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!ids.length) return;
      e.preventDefault();
      addItemsToCart(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), trigger);
      return;
    }
    var variantId = trigger.getAttribute('data-variant-id');
    if (!variantId) return; // let unconfigured buttons behave normally
    e.preventDefault();
    var qtyInput = trigger.getAttribute('data-wq-qty-from');
    var qty = 1;
    if (qtyInput) { var qi = document.querySelector(qtyInput); if (qi) qty = parseInt(qi.value, 10) || 1; }
    addToCart(variantId, qty, trigger);
  });

  /* ---------- 5. Variant -> price sync (simple buy section) -- */
  function money(cents) {
    try {
      return (window.Shopify && Shopify.currency)
        ? '$' + (cents / 100).toFixed(2)
        : '$' + (cents / 100).toFixed(2);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function initVariantForms(root) {
    (root || document).querySelectorAll('.wq[data-wq-product-form], .wq [data-wq-product-form]').forEach(function (form) {
      if (form.dataset.wqBound) return;
      form.dataset.wqBound = '1';
      var data = form.querySelector('[data-wq-variants]');
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      function selected() {
        var opts = [];
        form.querySelectorAll('[data-wq-option]').forEach(function (input) {
          if (input.type === 'radio') { if (input.checked) opts[+input.getAttribute('data-wq-option')] = input.value; }
          else opts[+input.getAttribute('data-wq-option')] = input.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return String(o) === String(opts[i]); });
        }) || variants[0];
      }
      function update() {
        var v = selected();
        if (!v) return;
        form.querySelectorAll('[name="id"]').forEach(function (el) { el.value = v.id; });
        form.querySelectorAll('[data-wq-add]').forEach(function (el) { el.setAttribute('data-variant-id', v.id); });
        form.querySelectorAll('[data-wq-price]').forEach(function (el) { el.textContent = v.price_formatted || money(v.price); });
        var addBtn = form.querySelector('[data-wq-add]');
        if (addBtn) {
          addBtn.toggleAttribute('disabled', !v.available);
          if (!v.available) addBtn.dataset.wqLabel = 'Sold out';
        }
        document.querySelectorAll('.wq .sticky-buy [data-wq-sticky-price]').forEach(function (el) { el.textContent = v.price_formatted || money(v.price); });
        document.querySelectorAll('.wq .sticky-buy [data-wq-add]').forEach(function (el) { el.setAttribute('data-variant-id', v.id); });
      }
      form.addEventListener('change', update);
      update();
    });
  }

  /* ---------- init ------------------------------------------- */
  function initAll(root) {
    initFaq(root);
    initMobileNav(root);
    initStickyBar(root);
    initVariantForms(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init inside Shopify theme editor when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
